import { createClient } from 'graphql-ws';
import { Environment, Network, Observable, RecordSource, Store, type FetchFunction, type SubscribeFunction } from 'relay-runtime';
import { signInRedirectFor } from './session/refusals.ts';
const HTTP_ENDPOINT = '/graphql';
const WS_ENDPOINT = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/graphql`;
const fetchFn: FetchFunction = async (params, variables) => {
  const res = await fetch(HTTP_ENDPOINT, {
    method: 'POST',
    // Already fetch's default, and stated because the whole session depends on
    // it: every field over owned data is scoped to the account this cookie
    // names, so a change to `omit` would sign every learner out with nothing
    // in the type system to notice.
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      query: params.text,
      variables
    })
  });
  const json = await res.json();
  // Auth §13: an expired session lands on sign-in rather than on whichever
  // feature happened to ask first reporting its own failure.
  const target = signInRedirectFor(json, location.pathname);
  if (target) location.assign(target);
  return json;
};
const wsClient = createClient({
  url: WS_ENDPOINT
});
const subscribeFn: SubscribeFunction = (params, variables) => Observable.create(sink => wsClient.subscribe({
  operationName: params.name,
  query: params.text ?? '',
  variables
}, {
  next: data => sink.next(data as never),
  error: err => sink.error(err as Error),
  complete: () => sink.complete()
}));
export const relayEnvironment = new Environment({
  network: Network.create(fetchFn, subscribeFn),
  store: new Store(new RecordSource())
});